import type { PageContext } from '@zto/zpage'

/** 标签新建 / 编辑（PRD §6：名称 ≤10、全局唯一由接口校验） */
export function tagEditDialog(isEdit: boolean) {
  return {
    width: 480,
    labelWidth: 100,
    itemSpan: 24,
    formItems: [
      {
        type: 'text',
        label: '标签ID',
        prop: 'tagCode',
        visibleOn: `${isEdit}`
      },
      {
        type: 'input',
        label: '标签名称',
        prop: 'tagName',
        maxlength: 10,
        trim: true,
        required: true
      }
    ],
    beforeSubmit: async ({ data }: PageContext) => {
      if (data.gmtCreate) delete data.gmtCreate
      const { tagName, tagCode } = data || {}
      return {
        tagName,
        tagCode
      }
    },
    actions: {
      close: {},
      submit: { label: '确定' }
    }
  }
}
